import React from 'react';
import { EuiCodeBlock, EuiLoadingSpinner, EuiCallOut } from '@elastic/eui';
import { ErrorDisplay } from '../../components/ErrorDisplay';
import ElementErrorBoundary from '../../components/ErrorBoundary/ElementErrorBoundary';
import { useSdpdsReadOnlyOperation } from '../../hooks/useSdpdsReadOnlyOperation';

export const ComponentVersionDescribe = (props) => {
  const { loading, data, error } = useSdpdsReadOnlyOperation({
    operation_name: "DescribeComponentVersion",
    payload: {
      stackName: props.stackName,
      componentVersion: {
        componentName: props.componentName,
        majorVersion: props.majorVersion,
        minorVersion: props.minorVersion,
        componentScopeDefinition: {
          componentScope: props.componentScope,
          componentScopeValue: props.componentScopeValue
        }
      }
    }
  });

  const renderContent = () => {
    return (
      <EuiCodeBlock
        language="json"
        fontSize="m"
        paddingSize="m"
        isCopyable
      >
        {JSON.stringify(data?.sdpdsReadOnlyOperation, null, 2)}
      </EuiCodeBlock>
    );
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
        <EuiLoadingSpinner size="xl" />
      </div>
    );
  }

  if (error) {
    return <ErrorDisplay />;
  }

  return (
    <ElementErrorBoundary>
      {renderContent()}
    </ElementErrorBoundary>
  );
};
